import {UserService} from "@nrwl/common-lib";
import {
  Component,
  AfterViewInit,
  OnDestroy,
  ChangeDetectorRef,
  OnInit,
  ViewChild,
  EventEmitter,
  ViewContainerRef,
  ComponentFactoryResolver
} from "@angular/core";
import { get, merge } from 'lodash';
import {Subscription} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {IWizardEntry} from "../../../wizard.entry";
import {WizardComponent} from "../../../wizard.component";
import {UpdateUserPasswordComponent} from "./update.user.password.component";
import { UpdateUserPasswordResultsComponent } from "../update-user-password-results/update-user-password-results.component";
import { UpdateUserPasswordService } from "../update-user-password.service";

@Component({
  selector: "update-user-password-wizard",
  providers: [
    UpdateUserPasswordService
  ],
  templateUrl: "../../../wizard.template.html",
  styleUrls: ['../../../wizard.component.style.scss', '../../../wizard.button.style.scss']
})
export class UpdateUserPasswordWizardComponent extends WizardComponent implements OnInit, AfterViewInit, OnDestroy, IWizardEntry {
  wizardConfig: any;
  wizardId: string;
  dataId: any;
  onClose = new EventEmitter<any>();

  wizardService: UpdateUserPasswordService;
  userService: UserService;
  openWizard: any;
  subscription: Subscription;
  changeDetectorRef: ChangeDetectorRef;

  @ViewChild('contentPlaceholder', { read: ViewContainerRef,
static: true }) contentRef: ViewContainerRef;
  @ViewChild('subContentPlaceholder', { read: ViewContainerRef,
static: true }) subContentRef: ViewContainerRef;

   constructor(
    wizardService: UpdateUserPasswordService,
    userService: UserService,
    changeDetectorRef: ChangeDetectorRef,
    private readonly activatedRoute: ActivatedRoute,
    private readonly factoryResolver: ComponentFactoryResolver
  ) {
    super();
    this.wizardService = wizardService;
    this.userService = userService;
    this.changeDetectorRef = changeDetectorRef;
  }

  ngOnInit() {
    this.subscription = this.activatedRoute.queryParams.subscribe((data) => {
      const defaultParams = merge({}, this.dataId, JSON.parse(get(data, 'defaultParams', "{}")));

      this.wizardService.editMode = true;

      this.wizardService.openWizard(this.wizardId, this.wizardConfig, defaultParams);
      this.wizardService.registerToggleListener(this.notifyOnToggleSubContent.bind(this));
    });
  }

  ngAfterViewInit() {
    this.createContentComponent();
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  get(object, path: string) {
    return get(object, path);
  }

  //-------------- Control && Validation -----------------------
  toggleNext() {
    this.wizardService.nextStep();
    this.createContentComponent();
  }

  toggleBack() {
    this.wizardService.previousStep();
    this.createContentComponent();
  }

  toggleFinish() {
    const result  = this.wizardService.onFinish();
    result.subscribe((outcome) => {
      this.createContentComponent()
    });
  }

  toggleClose() {
    this.wizardService.toggleClose(
      () => this.onClose.emit(true)
    );
  }

  toggleReOpen() {
    this.wizardService.reOpen();
  }

  notifyOnToggleSubContent(onOff) {
    if (onOff) {
      this.createSubContentComponent();
    } else {
      this.subContentRef.clear();
    }
  }

  getWizardService() {
    return this.wizardService;
  }

  getFactoryResolver() {
    return this.factoryResolver;
  }

  getContentViewRef() {
    return this.contentRef;
  }

  getSubContentViewRef() {
    return this.subContentRef;
  }

  resolveComponentType(pageId) {
    switch (pageId) {
      case 'user.password.html':
        return UpdateUserPasswordComponent;
      case 'update-user-password-results.component.html':
        return UpdateUserPasswordResultsComponent;
      default: {
        console.error('Unrecognized template name:', pageId);
        return null;
      }
    }
  }
  
}
